import { useGlobals } from '../contexts/appContext';
import { ExportButtonEnum } from '../models/enums/exportButton.enum';
import { LocalStorageKeys } from '../models/enums/localStorageKeys.enum';
import { SignalRMessageTypeEnum } from '../models/enums/signalRMessageType.enum';

export interface ExportLockConfig {
  exportButton: ExportButtonEnum;
  listenToSignal: SignalRMessageTypeEnum;
  localStorageKey: LocalStorageKeys;
}

export const EXPORT_BUTTON_LOCKS = [
  {
    exportButton: ExportButtonEnum.StatisticMemberRegisterExport,
    listenToSignal: SignalRMessageTypeEnum.ReceiveSnapshotCSVFile,
    localStorageKey: LocalStorageKeys.SnapshotExportInProgress,
  },
] as const satisfies readonly ExportLockConfig[];

// Initiera från LocalStorage (Checker för att kolla vilka knappar som är låsta)
export const loadLockedButtons = (): ExportButtonEnum[] =>
  EXPORT_BUTTON_LOCKS.filter((cfg) => localStorage.getItem(cfg.localStorageKey) === '1').map((cfg) => cfg.exportButton);

const getConfig = (btn: ExportButtonEnum) => EXPORT_BUTTON_LOCKS.find((x) => x.exportButton === btn);

export function useExportLockHandler() {
  const { exportLocks, setExportLocks } = useGlobals();

  const isExportButtonLocked = (btn: ExportButtonEnum): boolean => exportLocks.includes(btn);

  const lockExportBtnWhileCreating = (btn: ExportButtonEnum) => {
    const cfg = getConfig(btn);
    if (cfg) localStorage.setItem(cfg.localStorageKey, '1');
    setExportLocks((prev) => (prev.includes(btn) ? prev : [...prev, btn]));
  };

  const unlockExportBtn = (btn: ExportButtonEnum) => {
    const cfg = getConfig(btn);
    if (cfg) localStorage.removeItem(cfg.localStorageKey);
    setExportLocks((prev) => prev.filter((b) => b !== btn));
  };

  return {
    isExportButtonLocked,
    lockExportBtnWhileCreating,
    unlockExportBtn,
  };
}

export const clearAllExportLocksLocalStorage = () => {
  EXPORT_BUTTON_LOCKS.forEach((cfg) => localStorage.removeItem(cfg.localStorageKey));
};
